import gql from 'graphql-tag';

export const UPSERT_LENDER_PROFILE_ASSIGNMENT_TITLES = gql`
  mutation UpsertLenderProfileAssignmentTitles($input: UpsertLenderProfileAssignmentTitlesInput!) {
    upsertLenderProfileAssignmentTitles(input: $input) {
      lenderProfileAssignmentTitleId
      lenderProfileId
      userProfileId
      title
    }
  }
`;
